import { Injectable } from '@angular/core';
import moment from 'moment';
import { CoreModule } from '../core.module';
import { LocalStorageService } from './data/local-storage.service';

@Injectable({
	providedIn: CoreModule,
})
export class UtilitiesService {
	private _moment = moment;

	private _route;

	constructor(
		private localStorageService: LocalStorageService,
	) {}

	// moment
	get momentInstance() {
		return this._moment;
	}

	get route() {
		return this._route;
	}

	checkForMembershipIntentRoute() {
		const memberLevel = this.localStorageService.getData('membershipIntent');

		if (memberLevel) {
			// this.localStorageService.removeData('membershipIntent');
			this._route = memberLevel;
		}
	}

	uniqueArray(array, key) {
		const flags = {};
		return array.filter(
			(entry) => {
				if (flags[entry[key]]) {
					return false;
				}
				flags[entry[key]] = true;
				return true;
			},
		);
	}

	saveRoute(path) {
		if (this._route) return;
		this._route = path;
	}

	public round(value: number): number {
		return Math.round(value * 10) / 10;
	}

	/**
	 * Parses a user entered price e.g. "$5.99", "2,99" or "1.234,56" into a number.
	 * Returns NaN when the value can't be parsed.
	 */
	public formatStringToNumber(value: string | number | null | undefined): number {
		if (typeof value === 'number') return Number.isFinite(value) ? value : Number.NaN;
		if (typeof value !== 'string') return Number.NaN;

		const cleaned = value.replace(/[^\d.,-]/g, '');
		const lastComma = cleaned.lastIndexOf(',');
		const lastDot = cleaned.lastIndexOf('.');
		const decimalIndex = Math.max(lastComma, lastDot);
		const hasBothSeparators = lastComma !== -1 && lastDot !== -1;
		const isRepeatedSeparator = decimalIndex !== -1 && cleaned.indexOf(cleaned.charAt(decimalIndex)) !== decimalIndex;
		const hasDecimalPart = decimalIndex !== -1 && (hasBothSeparators || !isRepeatedSeparator);

		const integerPart = hasDecimalPart ? cleaned.slice(0, decimalIndex) : cleaned;
		const decimalPart = hasDecimalPart ? cleaned.slice(decimalIndex + 1) : '';

		const hasThousandsSeparators = /[.,]/.test(integerPart);
		if (hasThousandsSeparators && !/^-?\d{1,3}([.,])\d{3}(\1\d{3})*$/.test(integerPart)) return Number.NaN;

		const normalized = `${integerPart.replace(/[.,]/g, '')}.${decimalPart}`;
		if (!/^-?(\d+\.\d*|\.\d+)$/.test(normalized)) return Number.NaN;

		return Number(normalized);
	}

	// Removes leading/tailing/multiple spaces and line breaks
	// Used for feature description cleanup.
	trimStr(str: string) {
		if (!str) return str;

		return str.trim()
			.replace(/\s+|\n+/g, ' ');
	}
}
